<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="subgroupUsersProfileUpdate p-2 mt-2  border border-primary rounded " v-else>
      <div>
        <b-col class="m-1">
          <h5 style="font-size:1.7rem !important">How To Update!!</h5>
          <p style="font-size:1.2rem !important">
            Follow these steps to update data in a column (e.g., roll number or admission number of all students):
          </p>
          <ol>
            <li>
              <strong style="font-size:1.1rem !important">
                Select the column to update.</strong>
            </li>
            <li>
              <strong style="font-size:1.1rem !important">Optionally, copy and paste the existing data to an Excel
              </strong> file. To do this, copy all text from the data
              input field in Ezygo.app and paste it into a column in an Excel table.
            </li>

            <li>
              <strong style="font-size:1.1rem !important">After making modifications in the Excel table </strong>, copy
              the entire column. To do this, select all cells in the
              desired column, then copy (Ctrl+C).
            </li>
            <li>
              In Ezygo.app, <strong style="font-size:1.1rem !important">paste the Excel column data into the
                data input field</strong>, then click the <strong style="font-size:1.1rem !important">'Update Table'
                button</strong>.
              This will automatically update the data in the Ezygo table.
            </li>
            <li>
              You can now verify the existing data and new data for each student in the Ezygo table, and make any
              changes for specific students if needed.
            </li>
            <li>
              Click the <strong style="font-size:1.1rem !important">'Merge' button to temporarily update</strong> the
              data in the Ezygo table.
            </li>

            <li>
              Repeat the process to update another column (e.g., email address, phone number and so on).
            </li>

            <li>
              Finally, click the <strong style="font-size:1.1rem !important">'Save Changes Permanently'</strong> button
              to finish the process.
            </li>
          </ol>
          <p>If you're still unsure how to update data in a column, please contact Ezygo.app Support(+91 8330869500,
            support@ezygo.app) for assistance.</p>
        </b-col>

        <div class="border border-primary m-4"></div>
        <b-col class="m-1">
          <b-form-group label="Choose the column to be updated" v-slot="{ ariaDescribedby }">
            <b-form-radio-group id="radio-group-1" v-model="selectedColumn" @change="changeDataColumn()"
              :options="columnOptions" :aria-describedby="ariaDescribedby" name="radio-options"></b-form-radio-group>
          </b-form-group>
        </b-col>
        <div class="border border-secondary m-4"></div>
        <b-col class="m-1" v-if="selectedColumn != 'name'">
          <b-row>
            <b-col sm="6">
              <b-form-group label="Paste excel column data here (Data input field):" label-for="textarea-formatter"
                class="mb-0">
                <b-form-textarea :disabled="selectedColumnDatasArray.length > 0" v-model="selectedColumnDatasString"
                  id="textarea-formatter" rows="4" placeholder="Enter your text"></b-form-textarea>
              </b-form-group>
              <span v-if="selectedColumnDatasArray.length > 0" class="text text-danger">Merge changes or change column
                selection to enable this field
                again</span>
              <b-button :disabled="selectedColumnDatasArray.length > 0" variant="success" size="md"
                @click="updateTableFromInputData()">Update Table</b-button><br><br>
                <span class="text-danger" v-html="invalidDataErrormsg"></span>
            </b-col>
          </b-row>
        </b-col>
        <div class="border border-secondary m-4"></div>
        <b-col>
          <div class="table-container" style="overflow-x:auto; max-height: 400px;">      
          <table class="table  table-striped table-bordered">
            <thead class="thead-dark">
              <tr>
                <th>#</th>
                <th v-for="(column, index) in dynamicColumns" :key="index">
                  {{ column.text }}
                  <template v-if="selectedColumn === column.value && selectedColumnDatasArray.length > 0">
                    <br />
                    <b-button variant="success" size="md" @click="mergeTableFromInputData()">Merge</b-button>
                  </template>
                </th>
              </tr>
            </thead>
            <tbody class="profile-data-table">
              <tr v-for="(profile, reindex) in institutionUsersProfiles" :key="reindex">
                <td>{{ reindex + 1 }}</td>
                <td v-for="column in dynamicColumns" :key="column.value">
                  <!-- Name column: show first_name and last_name separately -->
                  <template v-if="column.value === 'name'">
                    <b-form-input
                      v-if="selectedColumn === 'name'"
                      v-model="profile.first_name"
                      :style="{
                        width: sLength(profile.first_name) * 7 + 'px',
                        'min-width': '50px',
                        'border-color': 'gray'
                      }"
                      placeholder="First Name"
                    ></b-form-input>
                    <b-form-input
                      v-if="selectedColumn === 'name'"
                      v-model="profile.last_name"
                      :style="{
                        width: sLength(profile.last_name) * 7 + 'px',
                        'min-width': '50px',
                        'border-color': 'gray'
                      }"
                      placeholder="Last Name"
                    ></b-form-input>
                    <span v-else>{{ profile.first_name }} {{ profile.last_name }}</span>
                  </template>

                  <!-- Merge column input -->
                  <template v-else-if="selectedColumn === column.value && selectedColumnDatasArray.length > 0">
                    <b-form-input
                      v-model="selectedColumnDatasArray[reindex]"
                      :placeholder="column.value"
                      :style="{
                        width: sLength(selectedColumnDatasArray[reindex]) * 7 + 'px',
                        'min-width': '50px',
                        'border-color': selectedColumnDatasArray[reindex] != profile[column.value] ? '#ffa300' : 'gray'
                      }"
                    ></b-form-input>
                  </template>

                  <!-- Default display -->
                  <template v-else>
                    <span>{{ profile[column.value] }}</span>
                  </template>
                </td>
              </tr>
            </tbody>   
          </table>
        </div> 
        </b-col>
        <!-- Fixed Buttons -->
        <b-col class="my-3">
          <div class="editOptions d-flex justify-content-between" style="position: sticky; bottom: 0; background-color: white; z-index: 10;">
            <span v-if="selectedColumnDatasArray.length > 0" class="text text-danger">
              Click 'merge' button before final submission to take effect the changes
            </span>
            <b-button variant="primary" size="md" :disabled="editProfile.disabled" @click="updatePorfiles()">
              {{ editProfile.text }}
            </b-button>
            <b-button variant="danger" size="md" :disabled="editProfile.disabled" @click="$emit('cancelProfile')">
              Cancel
            </b-button>
          </div>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
// import UserProfileQuesAns from "../../../institution_users/UserProfileQuesAns.vue"
// UserProfileQuesAns
import { AdmissionCategories } from './constants/AdmissionCategories';
import { reservationCategories } from './constants/reservationCategories';
import { bloodgroups } from './constants/bloodgroups';
import { guardianSiblingsRelationships } from './constants/guardianSiblingsRelationships';
import { religionCastes } from './constants/religionCastes';
import { regions } from './constants/regions';
export default {
  props: ["groupInfo", "institutionUserIds", "sortByOrder"],
  async created() {
    this.fetchData = await true;
    this.prepareRegions();
    this.prepareReligionCastes();
    await this.getUserProfiles();
  },
  components: {
    // UserProfileQuesAns
  },
  computed: {
    dynamicColumns() {
      const base = this.columnOptions;
      const selected = this.selectedColumn;
      const hasMerge = this.selectedColumnDatasArray.length > 0;

      if (!selected || !hasMerge || selected === 'name') {
        return base;
      }

      const reordered = [];
      for (const column of base) {
        if (column.value === 'name') {
          reordered.push(column);
          // Insert selected column immediately after "Name"
          const mergeCol = base.find(c => c.value === selected);
          if (mergeCol) reordered.push(mergeCol);
        } else if (column.value !== selected) {
          reordered.push(column);
        }
      }

      return reordered;
    }
  },
  data() {
    return {
      AdmissionCategories,
      bloodgroups,
      reservationCategories,
      guardianSiblingsRelationships,
      religionCastes,
      religions: [],
      castes: [],
      regions,
      countries: [], // List of countries
      states: [],
      districts: [],
      fetchData: false,
      institutionUsersProfiles: [],
      editProfile: {
        text: "Save changes permanently",
        disabled: false,
      },
      invalidDataErrormsg: "",
      columnOptions: [
        { text: "Name", value: "name" },
        { text: "Gender", value: "gender" },
        { text: "DOB (YYYY-MM-DD)", value: "birth_date" },
        { text: "Blood Group", value: "blood_group" },
        { text: "Email", value: "email" },
        { text: "Phone No", value: "mobile" },
        { text: "Roll No", value: "roll_number" },
        { text: "Admission No", value: "admission_no" },
        { text: "Category of Admission", value: "category_of_admission" },
        { text: "Registration No", value: "register_no" },
        { text: "Institution Last Attended(HSE)", value: "last_institution" },
        { text: "Code of Institution last attended", value: "code_of_institution_last_attended" },
        { text: "District of institution last attended", value: "district_of_institution_last_attended" }, 
        { text: "Aadhaar card no", value: "aadhaar_card_no" },
        { text: "Religion", value: "religion" },
        { text: "Caste", value: "caste" },
        { text: "Reservation Category", value: "reservation_category" },
        { text: "Date of joining (YYYY-MM-DD)", value: "date_of_joining" },
        { text: "Entrance Rank", value: "entrance_rank" },        
        { text: "Guardian Name", value: "guardian_name" },
        { text: "Guardian Relationship", value: "guardian_relationship" },
        { text: "Guardian Education", value: "guardian_education" },
        { text: "Guardian Occupation", value: "guardian_occupation" },
        { text: "Guardian Annual Income", value: "guardian_annual_income" },
        { text: "Guardian Phone No", value: "guardian_mobile" },
        { text: "Guardian Email", value: "guardian_email" },
        { text: "Sibling Name", value: "sibling_name" },
        { text: "Sibling Relationship", value: "sibling_relationship" },
        { text: "Sibling Education", value: "sibling_education" },
        { text: "Sibling Occupation", value: "sibling_occupation" },
        { text: "Sibling Annual Income", value: "sibling_annual_income" },
        { text: "Sibling Phone No", value: "sibling_mobile" },     
        { text: "Sibling Email", value: "sibling_email" },        
        { text: "House name/ Apartment Name (Communication Address)", value: "house_name_communication_address" },
        { text: "Town/ Locality (Communication Address)", value: "town_communication_address" },
        { text: "Pincode (Communication Address)", value: "pincode_communication_address" },
        { text: "Country (Communication Address)", value: "country_communication_address" },
        { text: "State (Communication Address)", value: "state_communication_address" },
        { text: "District (Communication Address)", value: "district_communication_address" },
        { text: "House name/ Apartment Name (Permanent Address)", value: "house_name_permanent_address" },
        { text: "Town/ Locality (Permanent Address)", value: "town_permanent_address" },
        { text: "Pincode (Permanent Address)", value: "pincode_permanent_address" },
        { text: "Country (Permanent Address)", value: "country_permanent_address" },
        { text: "State (Permanent Address)", value: "state_permanent_address" },
        { text: "District (Permanent Address)", value: "district_permanent_address" },
      ],
      selectedColumn: null,
      selectedColumnDatasString: "",
      selectedColumnDatasArray: [],
      // responseErrors: {},
      // responseSuccess: {},
      // genderOptions: [
      //   { value: "male", text: "Male" },
      //   { value: "female", text: "Female" },
      //   { value: "other", text: "Other" },
      // ],
      // genderSelection: {},
    };
  },
  methods: {
    sLength(string) { return string ? string.length : 1; },
    changeDataColumn() {
      this.invalidDataErrormsg = "";
      this.selectedColumnDatasString = "";
      this.selectedColumnDatasArray = [];
      this.institutionUsersProfiles.forEach((profile) => {
        this.selectedColumnDatasString = `${this.selectedColumnDatasString
          }${profile[this.selectedColumn] ?? ""}\n`;
      });
    },
    async updateTableFromInputData() {
      // Clear any existing error message and reset the input data array
      this.invalidDataErrormsg = "";
      this.selectedColumnDatasArray = [];
console.log("this.selectedColumnDatasString",this.selectedColumnDatasString);
      // Split the input string by new lines and trim whitespace from each entry
      let splitDataArray = this.selectedColumnDatasString.split(/\r?\n/).map(item => item.trim());


      // Populate selectedColumnDatasArray with cleaned input
      splitDataArray.forEach((data) => {
        this.selectedColumnDatasArray.push(data);
      });

      console.log("splitDataArray",this.selectedColumnDatasArray);

      // Prepare a list of valid values for the selected column (if applicable)
      let validValues = [];

      switch (this.selectedColumn) {
        case 'category_of_admission':
          validValues = AdmissionCategories.map(category => category.value);
          break;
        case 'blood_group':
          validValues = bloodgroups.map(blood => blood.value);
          break;
        case 'reservation_category':
          validValues = reservationCategories.map(r => r.value);
          break;
        case 'guardian_relationship':
        case 'sibling_relationship':
          validValues = guardianSiblingsRelationships.map(rel => rel.value);
          break;
        case 'religion':
          validValues = this.religions.map(religion => religion.value);
          break;
        case 'caste':
          validValues = this.castes.map(caste => caste.value);
          break;
        case 'country_communication_address':
        case 'country_permanent_address':
          validValues = this.countries.map(country => country.value);
          break;
        case 'state_communication_address':
        case 'state_permanent_address':
          validValues = this.states.map(state => state.value);
          break;
        case 'district_communication_address':
        case 'district_permanent_address':
          validValues = this.districts.map(district => district.value);
          break;
      }

      for (let index = 0; index < this.institutionUsersProfiles.length; index++) {
        // Skip if no data available for this index
        if (this.selectedColumnDatasArray.length <= index) break;

        let rawValue = this.selectedColumnDatasArray[index];

        // Skip if the value is null, undefined, or empty string
        if (!rawValue) continue;

        let value;

        // Normalize the value
        if (
          this.selectedColumn === 'category_of_admission' ||
          this.selectedColumn === 'blood_group' ||
          this.selectedColumn === 'reservation_category' ||
          this.selectedColumn === 'guardian_relationship' ||
          this.selectedColumn === 'sibling_relationship' ||
          this.selectedColumn === 'religion' ||
          this.selectedColumn === 'caste' ||
          this.selectedColumn === 'country_communication_address' ||
          this.selectedColumn === 'country_permanent_address' ||
          this.selectedColumn === 'state_communication_address' ||
          this.selectedColumn === 'state_permanent_address' ||
          this.selectedColumn === 'district_communication_address' ||
          this.selectedColumn === 'district_permanent_address'
        ) {
          value = rawValue.toLowerCase().replace(/ /g, "_");
        } else {
          value = rawValue;
        }

        this.selectedColumnDatasArray[index] = value;

        // Validate the value if required
        if (validValues.length > 0 && !validValues.includes(value)) {
          const columnLabel = this.selectedColumn
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '_');

          this.invalidDataErrormsg = `Invalid data entered for <strong>${columnLabel}</strong> at row ${index + 1}: ${value}`;
          this.selectedColumnDatasArray = [];
          return;
        }
      }

    },
    prepareRegions() {
      // Populate countries array from the regions data
      this.countries = this.regions.map((region) => ({
        value: region.slug,  // Using slug as value for consistency
        text: region.name,   // Using name as text for display
      }));
      // Initialize states and districts arrays
      this.states = [];
      this.districts = [];
      // Loop through regions and populate states and districts
      this.regions.forEach((region) => {
        if (region.states) { // Check if region.states is defined
          region.states.forEach((state) => {
            // Add state to states array
            this.states.push({
              value: state.slug, // Using slug for state
              text: state.name,  // Using name for state
            });
            if (state.districts) { // Check if state.districts is defined
              // Loop through districts in the state
              state.districts.forEach((district) => {
                // Add district to districts array
                this.districts.push({
                  value: district.slug, // Using slug for district
                  text: district.name,  // Using name for district
                });
              });
            }
          });
        }
      });
      this.$forceUpdate();
    },
     // Prepare religion and caste data
     prepareReligionCastes() {
      this.religions = [];
      this.castes = [];
      for (const [religion, data] of Object.entries(this.religionCastes)) {
        this.religions.push({
          value: data.value,
          text: religion,
        });
        // Add castes to the castes array for the specific religion
        data.castes.forEach(caste => {
          this.castes.push({
            value: caste.value,
            text: caste.name,
          });
        });
      }
    },
    
    mergeTableFromInputData() {
      for (
        let index = 0;
        index < this.institutionUsersProfiles.length;
        index++
      ) {
        if (this.selectedColumnDatasArray.length >= index)
          if (this.selectedColumn == 'gender') {
            if (['male', 'm', 'M', 'Male'].includes(this.selectedColumnDatasArray[index])) this.institutionUsersProfiles[index][
              this.selectedColumn
            ] = 'male';
            if (['female', 'f', 'F', 'Female'].includes(this.selectedColumnDatasArray[index])) this.institutionUsersProfiles[index][
              this.selectedColumn
            ] = 'female';
          } else {
            this.institutionUsersProfiles[index][
              this.selectedColumn
            ] = this.selectedColumnDatasArray[index];
          }
      }

      this.selectedColumn = null;
      this.selectedColumnDatasString = "";
      this.selectedColumnDatasArray = [];
    },
    async updatePorfiles() {
      this.editProfile.text = "Please Wait...";
      this.editProfile.disabled = true;
      let postData = [];

      for (let i in this.institutionUsersProfiles) {
        postData.push({
          id: this.institutionUsersProfiles[i].id,
          first_name: this.institutionUsersProfiles[i].first_name,
          last_name: this.institutionUsersProfiles[i].last_name,
          email: this.institutionUsersProfiles[i].email,
          gender: this.institutionUsersProfiles[i].gender,
          mobile: this.institutionUsersProfiles[i].mobile,
          birth_date: this.institutionUsersProfiles[i].birth_date,
          guardianData: {
            id: this.institutionUsersProfiles[i].guardian_id ?? null,
            name: this.institutionUsersProfiles[i].guardian_name ?? null,
            relationship: this.institutionUsersProfiles[i].guardian_relationship ?? null,
            education: this.institutionUsersProfiles[i].guardian_education ?? null,
            occupation: this.institutionUsersProfiles[i].guardian_occupation ?? null,
            annual_income: this.institutionUsersProfiles[i].guardian_annual_income ?? null,
            phone_number: this.institutionUsersProfiles[i].guardian_mobile ?? null,
            email: this.institutionUsersProfiles[i].guardian_email ?? null,
          },
          siblingData: {
            id: this.institutionUsersProfiles[i].sibling_id ?? null,
            name: this.institutionUsersProfiles[i].sibling_name ?? null,
            relationship: this.institutionUsersProfiles[i].sibling_relationship ?? null,
            education: this.institutionUsersProfiles[i].sibling_education ?? null,
            occupation: this.institutionUsersProfiles[i].sibling_occupation ?? null,
            annual_income: this.institutionUsersProfiles[i].sibling_annual_income ?? null,
            phone_number: this.institutionUsersProfiles[i].sibling_mobile ?? null,
            email: this.institutionUsersProfiles[i].sibling_email ?? null,
          },
          admission_no: this.institutionUsersProfiles[i].admission_no,
          last_institution: this.institutionUsersProfiles[i].last_institution,
          roll_number: this.institutionUsersProfiles[i].roll_number,
          register_no: this.institutionUsersProfiles[i].register_no,
          district_of_institution_last_attended: this.institutionUsersProfiles[i].district_of_institution_last_attended,
          code_of_institution_last_attended: this.institutionUsersProfiles[i].code_of_institution_last_attended,
          aadhaar_card_no: this.institutionUsersProfiles[i].aadhaar_card_no,
          date_of_joining: this.institutionUsersProfiles[i].date_of_joining,
          entrance_rank: this.institutionUsersProfiles[i].entrance_rank,
          institution_name: this.institutionUsersProfiles[i].institution_name,
          category_of_admission: this.institutionUsersProfiles[i].category_of_admission,
          reservation_category: this.institutionUsersProfiles[i].reservation_category,
          religion: this.institutionUsersProfiles[i].religion,
          caste: this.institutionUsersProfiles[i].caste,
          blood_group: this.institutionUsersProfiles[i].blood_group,
          house_name_communication_address: this.institutionUsersProfiles[i].house_name_communication_address,
          town_communication_address: this.institutionUsersProfiles[i].town_communication_address,
          pincode_communication_address: this.institutionUsersProfiles[i].pincode_communication_address,
          country_communication_address: this.institutionUsersProfiles[i].country_communication_address,
          state_communication_address: this.institutionUsersProfiles[i].state_communication_address,
          district_communication_address: this.institutionUsersProfiles[i].district_communication_address,
          house_name_permanent_address: this.institutionUsersProfiles[i].house_name_permanent_address,
          town_permanent_address: this.institutionUsersProfiles[i].town_permanent_address,
          pincode_permanent_address: this.institutionUsersProfiles[i].pincode_permanent_address,
          country_permanent_address: this.institutionUsersProfiles[i].country_permanent_address,
          state_permanent_address: this.institutionUsersProfiles[i].state_permanent_address,
          district_permanent_address: this.institutionUsersProfiles[i].district_permanent_address,
        });
      }

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usersubgroups/${this.groupInfo.id}/users/update`;
      await this.$axios
        .post(url, {
          usersubgroupusers: postData
        })
        .then(() => {
          this.$toast.success("Students data updated successfully", {
            position: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error(
            "Failed to update students data, please try again.",
            {
              position: "top",
              duration: 3000,
            }
          );
        });

      this.editProfile.disabled = false;
      this.editProfile.text = "Save changes permanently";
    },


    async getUserProfiles() {
      this.fetchData = true;

      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/profileindex`;
      const params = {
        usersubgroupId: this.groupInfo.id,
        institutionUserIds: this.institutionUserIds,
      };

      try {
        const response = await this.$axios.post(url, params);
        const profiles = response.data;
        this.institutionUsersProfiles = profiles.map((data) => {
          const updatedData = { ...data }; // avoid mutating original

          // Profile Data
          if (data.profile) {
            const p = data.profile;
            Object.assign(updatedData, {
              last_institution: p.last_institution || null,
              code_of_institution_last_attended: p.code_of_institution_last_attended || null,
              aadhaar_card_no: p.aadhaar_card_no || null,
              date_of_joining: p.date_of_joining || null,
              entrance_rank: p.entrance_rank || null,
              religion: p.religion || null,
              caste: p.caste || null,
              category_of_admission: p.category_of_admission || null,
              district_of_institution_last_attended: p.district_of_institution_last_attended || null,
              reservation_category: p.reservation_category || null,
              blood_group: p.blood_group || null,
              house_name_communication_address: p.house_name_communication_address || null,
              town_communication_address: p.town_communication_address || null,
              pincode_communication_address: p.pincode_communication_address || null,
              country_communication_address: p.country_communication_address || null,
              state_communication_address: p.state_communication_address || null,
              district_communication_address: p.district_communication_address || null,
              house_name_permanent_address: p.house_name_permanent_address || null,
              town_permanent_address: p.town_permanent_address || null,
              pincode_permanent_address: p.pincode_permanent_address || null,
              country_permanent_address: p.country_permanent_address || null,
              state_permanent_address: p.state_permanent_address || null,
              district_permanent_address: p.district_permanent_address || null,
            });
          }

          // Guardian Data
          if (Array.isArray(data.guardians) && data.guardians.length > 0) {
            const g = data.guardians[0];
            Object.assign(updatedData, {
              guardian_id: g.id || null,
              guardian_name: g.name || null,
              guardian_relationship: g.relationship || null,
              guardian_education: g.education || null,
              guardian_occupation: g.occupation || null,
              guardian_annual_income: g.annual_income || null,
              guardian_mobile: g.phone_number || null,
              guardian_email: g.email || null,
            });
          }

          // Sibling Data
          if (Array.isArray(data.siblings) && data.siblings.length > 0) {
            const s = data.siblings[0];
            Object.assign(updatedData, {
              sibling_id: s.id || null,
              sibling_name: s.name || null,
              sibling_relationship: s.relationship || null,
              sibling_education: s.education || null,
              sibling_occupation: s.occupation || null,
              sibling_annual_income: s.annual_income || null,
              sibling_mobile: s.phone_number || null,
              sibling_email: s.email || null,
            });
          }

          return updatedData;
        });

      } catch (error) {
        console.error("Error loading profiles:", error);
      } finally {
        this.fetchData = false;
      }
    }
  }
};
</script>

<style >
.profile-data-table input {
  padding: 0px;
  height: auto;
}

.data-change {
  border-color: "#ffa300" !important;
}

.highlight {
  font-weight: bold;            /* Bold text for the highlighted values */
  color: #0f0f0f;              
}
</style>
